<template>
  <div>
    <div>
      <label>{{ $t("NavBar.Midnight") }}</label>
    </div>
    <div>
      <InputSwitch @change="toggle" v-model="checked" />
    </div>
  </div>
</template>

<script>
import AccountService from "../../services/AccountService";
import LocalStorageService from "../../services/LocalStorageService";

export default {
  name: "EnableMidnightOption",
  accountService: null,
  created() {
    this.accountService = new AccountService();
    this.localStorageService = new LocalStorageService();
  },
  data() {
    return {
      checked: false,
      employee: null,
    };
  },
  mounted() {
    this.employee = this.localStorageService.getCurrentEmployee();
    this.checked = this.employee.isEnabledMidnightOption || false;
  },
  methods: {
    toggle() {
      this.loader = this.$loading.show({});
      this.accountService
        .updateEmployeeSetting("MidnightOption", this.checked.toString())
        .then((res) => {
          this.loader.hide();
          const result = res.data;
          this.localStorageService.setAuthToken(result.token);
          this.localStorageService.setCurrentEmployee(result.employee);
          this.employee = this.localStorageService.getCurrentEmployee();
          this.checked = this.employee.isEnabledMidnightOption || false;          
          window.location.reload();
        })
        .catch(() => {
          this.loader.hide();
        });
    },
  },
};
</script>
